const __int = ['0','1','2','3','4','5','6','7','8','9']
const __Symbol = ['.','~','!','@','#','$','%','^','&','*','(',')','-','+','`','<','>','?','/','\\','|','{','}','_','[',']',':','"',"'"]
const verification = {
    // 无符号整数验证
    int(data){
        for(let i in data){
            if(!__int.includes(data[i])){
                return {
                    state: false,
                    index: i,
                    index_data: data[i],
                    data: data,
                    error: data[i]+'数据格式不正确',
                }
            }
        }
        return {state:true};
    },
    // 无符号浮点数验证,num为浮点后位数
    float(data,num){
        for(let i in data){
            if( (!__int.includes(data[i])) && (data[i]!=__Symbol[0]) ){
                return {
                    state: false,
                    index: i,
                    index_data: data[i],
                    data: data,
                    errorCode: 1,
                    error: data[i]+'数据格式不正确',
                }
            }
        }
        let __Symbol_num = data.split(__Symbol[0])
        if(__Symbol_num.length > 2){
            return {
                state: false,
                dataList: __Symbol_num,
                iconNum: __Symbol_num.length-1,
                errorCode: 2,
                error: '数据中存在多个浮点',
            }
        }
        if(__Symbol_num[1] && __Symbol_num[1].length > num ){
            return{
                state: false,
                dataList: __Symbol_num,
                iconNum: __Symbol_num.length-1,
                length: __Symbol_num[1].length,
                errorCode: 3,
                error: '浮点位长度过长',
            }
        }
        return {state:true};
    }
}

export default verification;
